import React from 'react'
import get from 'lodash/get'

import Button from 'discada/dist/Button'

import DPILogo from 'static/images/DPILogo_Horizontal_Charcoal_RGB.svg'
import Progressive from 'static/images/progressive.svg'
import MetLife from 'static/images/metlife.svg'
import Travelers from 'static/images/travelers.svg'
import Nationwide from 'static/images/nationwide.svg'

import './Fastpass.scss'

const InsuranceLogo = ({ logoPath }) => {
  return (
    <div className="insurance-logo">
      <img src={logoPath} alt={logoPath} />
    </div>
  )
}

const InsuranceLogos = () => (
  <div className="insurance-logos">
    {[Progressive, MetLife, Travelers, Nationwide].map(p => (
      <InsuranceLogo logoPath={p} key={p} />
    ))}
  </div>
)

const DPLogo = () => (
  <div className="dealer-policy-logo">
    <img src={DPILogo} alt="Dealer Policy Insurance" />
  </div>
)

const DPCopy = () => (
  <div className="dealer-policy-copy barlow-medium-italic">
    <span>Drivers who save with us</span>
    <strong> Save an average of</strong>
    <strong className="savings">
      <span className="savings-dollars">
        <sup>$</sup>63
      </span>{' '}
      <span>
        per
        <br /> month
      </span>
    </strong>
    <strong>on their auto insurance.* </strong>
    <p className="roboto-light">
      Compare insurance quotes from multiple trusted brands to see if you can
      save.
    </p>
  </div>
)

const DPCTA = ({ fastpass }) => (
  <div className="dealer-policy-cta">
    <Button
      className="barlow-black-italic"
      href={get(fastpass, 'entryUrl', '#')}
      target="_blank"
      rel="noopener noreferrer"
    >
      Find Savings Now
    </Button>
    <p className="dealer-policy-asterisk roboto-light">
      *Based on 12,701 polices with savings sold by DealerPolicy Insurance
      Agency between 1/1/17 and 7/15/20
    </p>
  </div>
)

const FastPassBG = () => <div className="fastpass-bg" />

export function Fastpass(props) {
  return get(props.fastpass, 'entryUrl') || props.force ? (
    <div className="fastpass">
      <div className="column column-left">
        <DPLogo />
        <DPCopy />
        <InsuranceLogos />
      </div>
      <FastPassBG />
      <div className="column column-right">
        <DPCTA {...props} />
      </div>
    </div>
  ) : null
}

export default Fastpass
